module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!","ProfileList":"Profile List","CreateProfile":"Create Profile","UpdateProfile":"Update Profile","View":"View","usingprofile":"Room(s) using this profile","Action":"Action","Identify":"Identify","Department":"Department","Calendar":"Calendar","Order":"Order","Rules":"Rules","Norule":"No rule","ManageRule":"Manage Rule"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/profile/ENG.json
// module id = 901
// module chunks = 150